import {BS2} from "../BS2";

/**
 * Created by jonas on 2022-09-19.
 */

export class FreeSpinUtils {

    constructor() {
    }

    public static setKeypadSpinCounter(freespinsLeft: number): void {
        if (BS2.model.data.enhancedBet) {
            BS2.model.data.currentLevel > 1 || BS2.model.data.nextLevel > 1 ? BS2.keypadPlugin.setZeroBetSpinCounter(freespinsLeft) : BS2.keypadPlugin.setZeroBetSpinCounter(-1);
        } else {
            BS2.keypadPlugin.setZeroBetSpinCounter(freespinsLeft);
        }
    }


}